// extracted by mini-css-extract-plugin
export default {"display":"dashboard_display__NilBY","box":"dashboard_box__eYMi9","hi":"dashboard_hi__9Gaen","allbox":"dashboard_allbox__2Giml"};